import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

type CookieConfig = {
  expires?: number;
  domain?: string;
};

const defaultCookieConfig: CookieConfig = {
  expires: 60,
};

export const useQueryParamAndCookie = (
  paramName: string,
  cookieName = paramName,
  cookieConfig: CookieConfig = defaultCookieConfig,
  override = false
) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get(paramName);

  useEffect(() => {
    if (paramValue) {
      const cookieValue = Cookies.get(cookieName);

      if (!cookieValue || override) {
        Cookies.set(cookieName, paramValue, {
          ...defaultCookieConfig,
          ...cookieConfig,
        });
      }
    }
  }, [paramValue, cookieName, cookieConfig, override]);

  return {
    paramValue,
    cookieValue: Cookies.get(cookieName),
  };
};
